import {Routes} from '@angular/router';

import {AuthLayoutComponent} from './modules/layouts/auth/auth-layout.component';
import {ClientesLayoutComponent} from './modules/layouts/clientes/clientes-layout.component';
import {RoleGuardService} from './services/role-guard.service';
import {VisualizadorComponent} from './modules/visualizador/visualizador.component';
import {ForbiddenComponent} from './modules/shared/pages/forbidden.component';
import {EditorLayoutComponent} from './modules/layouts/editor/editor-layout.component';

export const AppRoutes: Routes = [
{
  path: '',
  component: ClientesLayoutComponent,
  children: [
  {
    path: '',
    loadChildren: './clientes/lele/lele.module#LeleModule'
  },
  {
    path: 'loja',
    loadChildren: './clientes/store/store.module#StoreModule'
  }
  ]
},
{
  path: '',
  component: VisualizadorComponent,
  canActivate: [RoleGuardService],
  children: [{
    path: 'visualizador',
    loadChildren: './modules/visualizador/visualizador.module#VisualizadorModule'
  }]
},
{
  path: 'erros',
  children: [{
    path: '403',
    component: ForbiddenComponent
  }]
}];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts